'use client';

const PVCBoots = (): JSX.Element => {
  const textClassName = 'text-[16px] leading-[26px] font-roboto-light font-light mb-[10px] lg_mb-[20px]';
  return (
    <div>
      <p className='mb-[10px] font-roboto-medium text-[18px] font-medium leading-[21px] lg_mb-[20px] lg_text-[20px] lg_leading-[28px]'>
        How to Wash and Dry
      </p>
      {[
        'Gently brush off dirt and other contaminants using a soft brush or cloth. Clean the surface with cold clean water, wipe dry with cloth. ',
        'Do not soak your PVC boots in solvents or heavy detergents. ',
        'Do not dry or store the PVC boots in direct sunlight or near a heat source. ',
        'Wipe down the insides of your boots and wash the footbeds using a mild detergent and water as required.',
      ].map((text, index) => (
        <p
          key={index}
          className={textClassName}
        >
          <span className='relative top-[-2px] mr-[10px] inline-block !h-[6px] !min-h-[6px] !w-[6px] !min-w-[6px] rounded-[6px] bg-[#000]'></span>
          {text}
        </p>
      ))}
    </div>
  );
};
export default PVCBoots;
